import React, { useMemo } from "react";
import ViewOptionsPanel from "../../../components/CustomUI/ViewOptionsPanel";
import { buildColumnSection } from "./buildListFilterSections";

const ListViewOptionsPanel = ({
  sections = [],
  filterSections = [],
  activeFilterCount = 0,
  onApply,
  onReset,
  showApply,
  showReset,
  columns = null,
  visibleColumns = [],
  onToggleColumn,
  onResetColumns,
  columnSections = [],
}) => {
  const allSections = useMemo(() => {
    const out = [];

    if (columnSections?.length) {
      columnSections.forEach((cfg) => {
        const section = buildColumnSection(cfg);
        if (section) out.push(section);
      });
    } else if (columns?.length && onToggleColumn) {
      const section = buildColumnSection({
        columns,
        visibleColumns,
        onToggle: onToggleColumn,
        onReset: onResetColumns,
      });
      if (section) out.push(section);
    }

    out.push(...filterSections, ...sections);
    return out;
  }, [
    sections,
    filterSections,
    columns,
    visibleColumns,
    onToggleColumn,
    onResetColumns,
    columnSections,
  ]);

  const hasDataFilters =
    filterSections.length > 0 ||
    sections.some((s) => s && s.type !== "columns") ||
    activeFilterCount > 0;

  return (
    <ViewOptionsPanel
      activeFilterCount={activeFilterCount}
      sections={allSections}
      onApply={onApply}
      onReset={onReset}
      showApply={showApply ?? hasDataFilters}
      showReset={showReset ?? hasDataFilters}
    />
  );
};

export default ListViewOptionsPanel;
